import type { PrintableCourseStudent } from '@/types/FlightSchoolStudent';
import { dateSortCriteria } from '@/functions/sortCriteria';

export type EnrollmentRow = PrintableCourseStudent & {
    isFocused: boolean;
};

export const searchTableColumns = [
    {
        name: 'id', label: 'ID', field: 'id', sortable: true, align: 'left' as const,
    },
    {
        name: 'name', label: 'Student', field: 'name', sortable: true, align: 'left' as const,
    },
    {
        name: 'email', label: 'Email', field: 'email', sortable: true, align: 'left' as const,
    },
    {
        name: 'school', label: 'School', field: 'schoolName', sortable: true, align: 'left' as const,
    },
    {
        name: 'part', label: 'Part', field: 'part', sortable: true, align: 'left' as const,
    },
    {
        name: 'certificate', label: 'Course', field: 'courseName', sortable: true, align: 'left' as const,
    },
    {
        name: 'rating', label: 'Rating', field: 'ratingAcronym', sortable: true, align: 'left' as const,
    },
    {
        name: 'enrollDate', label: 'Enrollment Date', field: 'enrollDateString', sortable: true, sort: dateSortCriteria, align: 'left' as const,
    },
    {
        name: 'lastAccess', label: 'Last Course Access', field: 'lastAccessString', sortable: true, sort: dateSortCriteria, align: 'left' as const,
    },
    {
        name: 'courseStatus', label: 'Course Status', field: 'courseStatus', sortable: true, align: 'left' as const,
    },
    {
        name: 'examStatus', label: 'Exam Status', field: 'examStatus', sortable: true, align: 'left' as const,
    },
];
